export const UPDATE_JACKPOTS = "UPDATE_JACKPOTS";

export const JACKPOTS_STORAGE_KEY = "jackpots";

export const updateJackpots = (jackpotGroups, publishTime = null) => ({
    type: UPDATE_JACKPOTS,
    jackpotGroups,
    publishTime,
});
